// 阿里oss签名获取
import 'lib/aliossAccess.js';
import 'vue-video-player/src/custom-theme.css';
import Vue from 'vue';
import VueRouter from 'vue-router';
import router from './router';
import store from 'store';
import 'theme/normal.scss';
import 'theme/main.scss';
import ElementUI from 'element-ui';
import {VueHttp} from 'lib/http';
import 'element-ui/lib/theme-chalk/index.css';
import ECharts from 'vue-echarts';
import Carousel3d from 'vue-carousel-3d';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import {swiper, swiperSlide} from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import Editor from 'components/RichText/editor';
import VideoPlayer from 'vue-video-player';
import 'video.js/dist/video-js.css';
import VueScrollTo from 'vue-scrollto';
import 'animate.css';
import chinaMap from './assets/js/china.json';
import hunanMap from './assets/js/hunan.json';
import Viewer from 'v-viewer';
import scroll from 'vue-seamless-scroll';
import VueAMap from 'vue-amap';
import formCreate from '@form-create/element-ui'
import FcDesigner from '@form-create/designer'
Vue.use(formCreate)
Vue.use(FcDesigner)
Vue.use(VueAMap);
// 初始化vue-amap
VueAMap.initAMapApiLoader({
  // 高德的key
  key: '1f00ba2e4aa1532abcaeb7dbc7dd0203',
  // 插件集合
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
  ],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.4',
});

import {IndexBar, IndexAnchor, Search, List, Cell, PullRefresh,ActionSheet } from 'vant';
Vue.use(IndexBar);
Vue.use(IndexAnchor);
Vue.use(Search);
Vue.use(List);
Vue.use(Cell);
Vue.use(PullRefresh);
Vue.use(ActionSheet);



Vue.use(scroll);
Vue.use(Viewer);
ECharts.registerMap('china', chinaMap);
ECharts.registerMap('hunan', hunanMap);
Vue.component('echarts', ECharts);
Vue.use(VideoPlayer);
Vue.use(VueRouter);
Vue.use(ElementUI);
Vue.use(Editor);
Vue.use(VueHttp);
Vue.use(Carousel3d);
Vue.use(VueAwesomeSwiper);
Vue.component('swiper', swiper);
Vue.component('swiperSlide', swiperSlide);
Vue.config.productionTip = false;

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
 
Vue.prototype.$echarts = ECharts;
new Vue({
  el: '#app',
  router,
  store,
  template: '<router-view/>',
});
